import type { ComponentProps } from 'react';
import { OwcCheckbox } from '@one/react';

export type PocCheckboxProps = ComponentProps<typeof OwcCheckbox>;

export const PocCheckbox: React.FC<PocCheckboxProps> = (props) => <OwcCheckbox {...props} />;
